import { useDispatch, useSelector } from 'react-redux'
import { YearTabCommon } from '../../../yearTabCommon'
import { changeYear, selectRealYears, selectYear } from '../../store/slice'

export const YearTab = () => {
  const dispatch = useDispatch()

  const year = useSelector(selectYear)
  const years = useSelector(selectRealYears)

  const onClick = (item) => {
    dispatch(changeYear(item))
  }

  return <YearTabCommon tab={year} data={years} onClick={onClick} />
}
